import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCAPzjJ9V9BfDm2V2ZNnWTyh9O-M-xSj5s",
  authDomain: "psyco-d2df6.firebaseapp.com",
  projectId: "psyco-d2df6",
  storageBucket: "psyco-d2df6.appspot.com",
  messagingSenderId: "701005867850",
  appId: "1:701005867850:web:1ea9668c3ce6e57386afb3"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app);
const db = getFirestore(app);

export { db, auth, functions };
